import React from 'react';
interface SectionHeadingProps {
  title: string;
  description?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
  as?: 'h1' | 'h2';
}
export function SectionHeading({
  title,
  description,
  align = 'left',
  tone = 'light',
  as = 'h2'
}: SectionHeadingProps) {
  const Tag = as;
  return <div className={`max-w-2xl ${align === 'center' ? 'mx-auto text-center' : ''}`} data-id="element-304" data-mp="3jzdocopo5ue0">
      <Tag className={`font-display text-3xl font-bold tracking-tight sm:text-4xl ${tone === 'dark' ? 'text-white' : 'text-navy-900'}`} data-id="element-305" data-mp="bk3o7m5caz8v">
        {title}
      </Tag>
      {description && <p className={`mt-4 text-lg leading-relaxed ${tone === 'dark' ? 'text-navy-200' : 'text-navy-600'}`} data-id="element-306" data-mp="1u0wrqdv9tcn">
          {description}
        </p>}
    </div>;
}